import { GraphQLLayoutService, RestLayoutService, constants } from '@sitecore-jss/sitecore-jss-react';
import { AxiosDataFetcher } from '@sitecore-jss/sitecore-jss';
import config from '../temp/config';
// Custom data fetcher function that appends a 'ref' query parameter if it exists in the URL
function dataFetcher(url, data) {
    // Parse the current URL's query parameters
    const urlParams = new URLSearchParams(window.location.search);
    // Get the 'ref' parameter from the query string
    const ref = urlParams.get('ref');
    // If 'ref' exists, append it to the URL as a query parameter
    if (ref) {
        url += `&ref=${ref}`;
    }

    // Use AxiosDataFetcher to perform the fetch operation
    return new AxiosDataFetcher().fetch(url);
}

export class LayoutServiceFactory {
  create() {
    return process.env.REACT_APP_FETCH_WITH === constants.FETCH_WITH.GRAPHQL
      ? new GraphQLLayoutService({
          endpoint: config.graphQLEndpoint,
          apiKey: config.sitecoreApiKey,
          siteName: config.jssAppName,
        })
      : new RestLayoutService({
          apiHost: config.sitecoreApiHost,
          apiKey: config.sitecoreApiKey,
          siteName: config.jssAppName,
          configurationName: 'default',
          dataFetcherResolver: () => dataFetcher,
        });
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
